var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._g(_vm._b({staticClass:"tr-form text-regular",class:{
		'form--tight': !_vm.isInline && _vm.spacing === _vm.Spacing.TIGHT,
		'form--regular': !_vm.isInline && _vm.spacing === _vm.Spacing.REGULAR,
		'form--wide': !_vm.isInline && _vm.spacing === _vm.Spacing.WIDE,
		'form--loose': !_vm.isInline && _vm.spacing === _vm.Spacing.LOOSE,
		'form--extra-loose': !_vm.isInline && _vm.spacing === _vm.Spacing.EXTRA_LOOSE,
	}},'form',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }